// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoRefreshOutlinedSvg from "@fishx/icons-svg/es/asn/PtoRefreshOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoRefreshOutlined = function PtoRefreshOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoRefreshOutlinedSvg
  }));
};

PtoRefreshOutlined.displayName = 'PtoRefreshOutlined';
export default React.forwardRef(PtoRefreshOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoRefreshOutlined.js
// module id = 3917
// module chunks = 0